import { Injector, LOCALE_ID } from '@angular/core';
import { Validators } from '@angular/forms';
import { BodyClasses, ColumnSizes, FieldSelectOption, FilterType } from 'components';
import { DateDisplayPipe } from 'projects/components/src/lib/shared/pipes/date-display/date-display.pipe';
import { LocationsLookupService } from '../../../../core/services/lookup';
import { Report } from '../../models/report';
import { PatientMixService } from './patient-mix.service';
import { PercentPipe } from '@angular/common';

export const PatientMix: Report = {
  id: 'patient-mix',
  label: 'Patient Mix',
  textCriteria: { 'Report Date Type': '', 'Report Date': '', 'Locations': '' },
  cleanFilterParams: {
    'locationIds': ''
  },
  getReportTitle: () => {
    return PatientMix.label + ' - ' + PatientMix.textCriteria['Report Date']
  },
  getSearchCriteria: (injector: Injector) => [
    {
      title: '',
      controls: [
        {
          label: 'Report Date Type',
          name: 'reportDateType',
          type: 'select',
          class: 'form-span-6',
          options: [
            {
              label: 'Service Date',
              value: 'S'
            },
            {
              label: 'Posting Date',
              value: 'P'
            }
          ],
          validators: Validators.required,
          selectionChanged: (event) => {
            PatientMix.textCriteria['Report Date Type'] = event.source.triggerValue;
          }
        },
        {
          label: 'Date',
          name: 'reportDate',
          class: 'form-span-6',
          type: 'date',
          validators: Validators.required,
          datepickerChanged: (event) => {
            PatientMix.textCriteria['Report Date'] = event.value.toLocaleDateString();
          }
        },
        {
          matLabel: 'Location',
          name: 'locationIds',
          apiService: injector.get(LocationsLookupService),
          type: 'multiSelect',
          class: 'form-span-12 multi-input',
          placeholder: 'Location',
          selectOptions: (event) => {
            let listValue = []
            let listText = []
            event.forEach((x: FieldSelectOption) => {

              listValue.push(x.value)
              listText.push(x.label)
            })
            PatientMix.textCriteria['Locations'] = listText.join(',');
            PatientMix.cleanFilterParams['locationIds'] = listValue
          }
        }
      ]
    }
  ],
  getGridConfiguration: (injector: Injector) => {
    const locale = injector.get(LOCALE_ID);
    const datePipe: DateDisplayPipe = new DateDisplayPipe(locale);
    const percentPipe: PercentPipe = new PercentPipe(locale);
    const moneyFormat = new Intl.NumberFormat('en-us', { style: 'currency', currency: 'USD' });
    return {
      service: injector.get<any>(PatientMixService),
      columnDefinitions: [
        {
          id: 'Category',
          displayKey: 'Section',
          headerText: 'Category',
          displayOrder: 0,
          columnSize: ColumnSizes.normal,
          sortable: true,
          filterable: true
        },
        {
          id: 'FinancialClass',
          displayKey: 'Financial Class',
          headerText: 'Financial Class',
          displayOrder: 1,
          columnSize: ColumnSizes.normal,
          sortable: true,
          filterable: true
        },
        {
          id: 'Dynamic Column 2',
          displayKey: 'Dynamic Column 2',
          headerText: 'Dynamic Column 2',
          dynamic: true,
          displayOrder: 2,
          columnSize: ColumnSizes.normal,
          sortable: true,
          filterable: true,
          sortColumnType: 'number',
          filterConfig: {
            filterType: FilterType.number
          },
        },
        {
          id: 'Dynamic Column 3',
          displayKey: 'Dynamic Column 3',
          headerText: 'Dynamic Column 3',
          dynamic: true,
          displayOrder: 3,
          columnSize: ColumnSizes.normal,
          sortable: true,
          filterable: true,
          sortColumnType: 'number',
          filterConfig: {
            filterType: FilterType.number
          },
        },
        {
          id: 'Dynamic Column 4',
          displayKey: 'Dynamic Column 4',
          headerText: 'Dynamic Column 4',
          dynamic: true,
          displayOrder: 4,
          columnSize: ColumnSizes.normal,
          sortable: true,
          filterable: true,
          sortColumnType: 'number',
          filterConfig: {
            filterType: FilterType.number
          },
        },
        {
          id: 'Dynamic Column 5',
          displayKey: 'Dynamic Column 5',
          headerText: 'Dynamic Column 5',
          dynamic: true,
          displayOrder: 5,
          columnSize: ColumnSizes.normal,
          sortable: true,
          filterable: true,
          sortColumnType: 'number',
          filterConfig: {
            filterType: FilterType.number
          },
        },
        {
          id: 'Dynamic Column 6',
          displayKey: 'Dynamic Column 6',
          headerText: 'Dynamic Column 6',
          dynamic: true,
          displayOrder: 6,
          columnSize: ColumnSizes.normal,
          sortable: true,
          filterable: true,
          sortColumnType: 'number',
          filterConfig: {
            filterType: FilterType.number
          },
        },
        {
          id: 'Dynamic Column 7',
          displayKey: 'Dynamic Column 7',
          headerText: 'Dynamic Column 7',
          dynamic: true,
          displayOrder: 7,
          columnSize: ColumnSizes.normal,
          sortable: true,
          filterable: true,
          sortColumnType: 'number',
          filterConfig: {
            filterType: FilterType.number
          },
        },
        {
          id: 'Dynamic Column 8',
          displayKey: 'Dynamic Column 8',
          headerText: 'Dynamic Column 8',
          dynamic: true,
          displayOrder: 8,
          columnSize: ColumnSizes.normal,
          sortable: true,
          filterable: true,
          sortColumnType: 'number',
          filterConfig: {
            filterType: FilterType.number
          },
        },
        {
          id: 'Dynamic Column 9',
          displayKey: 'Dynamic Column 9',
          headerText: 'Dynamic Column 9',
          dynamic: true,
          displayOrder: 9,
          columnSize: ColumnSizes.normal,
          sortable: true,
          filterable: true,
          sortColumnType: 'number',
          filterConfig: {
            filterType: FilterType.number
          },
        },
        {
          id: 'Dynamic Column 10',
          displayKey: 'Dynamic Column 10',
          headerText: 'Dynamic Column 10',
          dynamic: true,
          displayOrder: 10,
          columnSize: ColumnSizes.normal,
          sortable: true,
          filterable: true,
          sortColumnType: 'number',
          filterConfig: {
            filterType: FilterType.number
          },
        },
        {
          id: 'Dynamic Column 11',
          displayKey: 'Dynamic Column 11',
          headerText: 'Dynamic Column 11',
          dynamic: true,
          displayOrder: 11,
          columnSize: ColumnSizes.normal,
          sortable: true,
          filterable: true,
          sortColumnType: 'number',
          filterConfig: {
            filterType: FilterType.number
          },
        },
        {
          id: 'Dynamic Column 12',
          displayKey: 'Dynamic Column 12',
          headerText: 'Dynamic Column 12',
          dynamic: true,
          displayOrder: 12,
          columnSize: ColumnSizes.normal,
          sortable: true,
          filterable: true,
          sortColumnType: 'number',
          filterConfig: {
            filterType: FilterType.number
          },
        },
        {
          id: 'Dynamic Column 13',
          displayKey: 'Dynamic Column 13',
          headerText: 'Dynamic Column 13',
          dynamic: true,
          displayOrder: 13,
          columnSize: ColumnSizes.normal,
          sortable: true,
          filterable: true,
          sortColumnType: 'number',
          filterConfig: {
            filterType: FilterType.number
          },
        },
        {
          id: 'Dynamic Column 14',
          displayKey: 'Dynamic Column 14',
          headerText: 'Dynamic Column 14',
          dynamic: true,
          displayOrder: 14,
          columnSize: ColumnSizes.normal,
          sortable: true,
          filterable: true,
          sortColumnType: 'number',
          filterConfig: {
            filterType: FilterType.number
          },
        },
        {
          id: 'Dynamic Column 15',
          displayKey: 'Dynamic Column 15',
          headerText: 'Dynamic Column 15',
          dynamic: true,
          displayOrder: 15,
          columnSize: ColumnSizes.normal,
          sortable: true,
          filterable: true,
          sortColumnType: 'number',
          filterConfig: {
            filterType: FilterType.number
          },
        },
        {
          id: 'Dynamic Column 16',
          displayKey: 'Dynamic Column 16',
          headerText: 'Dynamic Column 16',
          dynamic: true,
          displayOrder: 16,
          columnSize: ColumnSizes.normal,
          sortable: true,
          filterable: true,
          sortColumnType: 'number',
          filterConfig: {
            filterType: FilterType.number
          },
        },
        {
          id: 'Dynamic Column 17',
          displayKey: 'Dynamic Column 17',
          headerText: 'Dynamic Column 17',
          dynamic: true,
          displayOrder: 17,
          columnSize: ColumnSizes.normal,
          sortable: true,
          filterable: true,
          sortColumnType: 'number',
          filterConfig: {
            filterType: FilterType.number
          },
        },
        {
          id: 'Dynamic Column 18',
          displayKey: 'Dynamic Column 18',
          headerText: 'Dynamic Column 18',
          dynamic: true,
          displayOrder: 18,
          columnSize: ColumnSizes.normal,
          sortable: true,
          filterable: true,
          sortColumnType: 'number',
          filterConfig: {
            filterType: FilterType.number
          },
        },
        {
          id: 'Dynamic Column 19',
          displayKey: 'Dynamic Column 19',
          headerText: 'Dynamic Column 19',
          dynamic: true,
          displayOrder: 19,
          columnSize: ColumnSizes.normal,
          sortable: true,
          filterable: true,
          sortColumnType: 'number',
          filterConfig: {
            filterType: FilterType.number
          },
        },
        {
          id: 'Dynamic Column 20',
          displayKey: 'Dynamic Column 20',
          headerText: 'Dynamic Column 20',
          dynamic: true,
          displayOrder: 20,
          columnSize: ColumnSizes.normal,
          sortable: true,
          filterable: true,
          sortColumnType: 'number',
          filterConfig: {
            filterType: FilterType.number
          },
        },
        {
          id: 'Dynamic Column 21',
          displayKey: 'Dynamic Column 21',
          headerText: 'Dynamic Column 21',
          dynamic: true,
          displayOrder: 21,
          columnSize: ColumnSizes.narrow,
          sortable: true,
          filterable: true
        },
        {
          id: 'Dynamic Column 22',
          displayKey: 'Dynamic Column 22',
          headerText: 'Dynamic Column 22',
          dynamic: true,
          displayOrder: 22,
          columnSize: ColumnSizes.normal,
          sortable: true,
          filterable: true,
          sortColumnType: 'number',
          filterConfig: {
            filterType: FilterType.number
          },
        },
        {
          id: 'Dynamic Column 23',
          displayKey: 'Dynamic Column 23',
          headerText: 'Dynamic Column 23',
          dynamic: true,
          displayOrder: 23,
          columnSize: ColumnSizes.normal,
          sortable: true,
          filterable: true,
          sortColumnType: 'number',
          filterConfig: {
            filterType: FilterType.number
          },
        },
        {
          id: 'Dynamic Column 24',
          displayKey: 'Dynamic Column 24',
          headerText: 'Dynamic Column 24',
          dynamic: true,
          displayOrder: 24,
          columnSize: ColumnSizes.normal,
          sortable: true,
          filterable: true,
          sortColumnType: 'number',
          filterConfig: {
            filterType: FilterType.number
          },
        },
        {
          id: 'Dynamic Column 25',
          displayKey: 'Dynamic Column 25',
          headerText: 'Dynamic Column 25',
          dynamic: true,
          displayOrder: 25,
          columnSize: ColumnSizes.normal,
          sortable: true,
          filterable: true,
          sortColumnType: 'number',
          filterConfig: {
            filterType: FilterType.number
          },
        },
        {
          id: 'Dynamic Column 26',
          displayKey: 'Dynamic Column 26',
          headerText: 'Dynamic Column 26',
          dynamic: true,
          displayOrder: 26,
          columnSize: ColumnSizes.normal,
          sortable: true,
          filterable: true,
          sortColumnType: 'number',
          filterConfig: {
            filterType: FilterType.number
          },
        }
      ]
    };
  }
};
